export enum IconType {
	solid = 'fa-solid',
	regular = 'fa-regular',
	brands = 'fa-brands'
}
